import { repeat } from 'lodash';

// m x n items (rows and cols simultaneously)

function positionIE11Grid(_ref) {
  var rows = _ref.rows,
      cols = _ref.cols,
      childNumber = _ref.childNumber;
  var css = '';

  if (Array.isArray(rows) && rows.length === 0 || !rows) {
    for (var x = 0; x <= childNumber; x++) {
      // :nth-child() doesn't work in ie11
      css = css.concat("& > div ".concat(repeat('+ div ', x), "{ -ms-grid-column: ").concat(x + 1, "; } "));
    }
  }

  if (Array.isArray(cols) && cols.length === 0 || !cols) {
    for (var _x = 0; _x <= childNumber; _x++) {
      css = css.concat("& > div ".concat(repeat('+ div ', _x), "{ -ms-grid-row: ").concat(_x + 1, "; } "));
    }
  }

  return css;
}

export { positionIE11Grid };
//# sourceMappingURL=ie11.js.map
